export default __webpack_public_path__ + "static/media/caret.ed6b81be.svg";